export default "__VITE_ASSET__8kumHETD__"